/**
 * Singleton host for ImageLightbox. Mount this ONCE (e.g. in EditorPage) and
 * any component can open the lightbox by dispatching:
 *
 *   window.dispatchEvent(new CustomEvent('openImageLightbox', {
 *     detail: { src, alt },
 *   }));
 *
 * This decouples triggers (ImageNodeView double-click, gallery, etc.) from
 * where the modal is mounted.
 */
import React, { useEffect, useState } from 'react';
import ImageLightbox from './ImageLightbox';

const ImageLightboxHost = () => {
  const [state, setState] = useState({ open: false, src: null, alt: '' });

  useEffect(() => {
    const onOpen = (e) => {
      setState({ open: true, src: e.detail?.src ?? null, alt: e.detail?.alt ?? '' });
    };
    window.addEventListener('openImageLightbox', onOpen);
    return () => window.removeEventListener('openImageLightbox', onOpen);
  }, []);

  return (
    <ImageLightbox
      open={state.open}
      onOpenChange={(open) => setState((prev) => ({ ...prev, open }))}
      src={state.src}
      alt={state.alt}
    />
  );
};

export default ImageLightboxHost;
